import Api from "../axios";

export default async function apiHolidayList() {
  return await Api.get("/holiday_list");
}
